// extracted by mini-css-extract-plugin
module.exports = {"infotag":"InfoLink_infotag__1armu","linkable":"InfoLink_linkable__1Wo2H"};